import { ProStudioContext } from '../xstate/prostudio.xstate.types';

/**
 * The `bot_id` that scopes pype reads to the selected solution.
 *
 * The V6 pype list filters each pype's streams by `start_chat_bot_id` and then
 * drops pypes left with no streams (pype_controller.ex `index_with_streams_and_widgets`),
 * so passing this narrows the result to the pypes that actually back a channel of
 * this solution. Omitting it returns every pype on the customer.
 *
 * The route carries the solution's name, not its id, hence the lookup — a
 * solution is addressed by `name` or `displayName` depending on where the link
 * came from.
 */
export const resolveBotSolutionId = (
  ctx: Pick<ProStudioContext, 'solutions' | 'botName'>
): string | undefined => {
  const { solutions, botName } = ctx;
  if (!botName) {
    return undefined;
  }
  return solutions?.find(
    (solution) => solution.name === botName || solution.displayName === botName
  )?.botSolutionId;
};
